import { useTranslation } from "react-i18next";
import "./index.css"
import * as ReactBootstrap from "react-bootstrap";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { createHazardAssessment, postRepairPriority } from "../../api";
import { CreateHazardRequest, HazardResponseRequest } from "../../models/ReferenceData/HazardAssessment";
import { RepairPriorityPayload } from '../../models/Repair/RepairPriority';
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { detectMobile, isNullOrUndefined } from "../../utils/formatting";
import moment from "moment";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import * as api from "../../api";
import { saveHazardAccessResponse, saveHazardPostAssessmentResponse, saveHHSRSAssessmentCompleted } from '../../ducks/redux/actions/hazardAssessment';
import { repairPriorityValue } from "../../ducks/redux/actions/userChoices";
import HeaderJourney from "../../storybook/Header/HeaderJourney";
import BackModal from "../Modal/BackModal";
import ExitModal from "../Modal/ExitModal";
import Button from "../../storybook/Button";
import { Helper } from "../../utils/Helper/HelperUtil";
const HazardReview = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const hazardDetailsraw = useSelector((state: any) => state?.hazard?.responses);
  const hazardDetails = [...(hazardDetailsraw || [])].sort(
    (a: any, b: any) => Number(a.sequence) - Number(b.sequence),
  );
  const hazardQuestions = useSelector((state: any) => state?.hazard?.hazardQuestions || []);
  const isAdditionalNeedsUser = useSelector((state: any) => state?.userChoicesReducer?.hasAdditionalNeeds);
  const supportedResident = useSelector((state: any) => state?.userChoicesReducer?.isSupportedResident);
  const selectedRepairReasonObj = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject);
  const assetDetails = useSelector((state: any) => state.dashboardReducer?.formState?.eligibilityResponseObject);
  const workOrderObject = useSelector(
    (state: any) => state?.addresses?.workOrderRepair
  );


  const assessmentDetails = hazardDetails?.filter((item: any) => !item.isPreAssessment) || [];
  const customerAdditionalAlertData = useSelector((state: any) => state?.userChoicesReducer?.customerAdditionalAlertData);
  const isAnaTypeValue = customerAdditionalAlertData?.length > 0;
  const customerDetails = useSelector((state: any) => state?.addresses?.saveCustomerDetails);
  const isEnhancedDiagnosticsRepair = workOrderObject?.isEnhancedDiagnosticsRepair;
  const repairDiagnosticData = useSelector((state: any) => state?.userChoicesReducer?.repairDiagnosticFinalData);
  const selectedRepairReasonObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonObject)
  const userChosenSOR = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const priorityWorkProgramme = userChosenSOR !== ""
    ? (selectedRepairReasonObject?.[0]?.sors?.find((sor: any) => sor?.sorCode === userChosenSOR)?.workProgramme
      ?? selectedRepairReasonObject?.[0]?.sors?.[0]?.workProgramme)
    : selectedRepairReasonObject?.[0]?.sors?.[0]?.workProgramme;
  const navigateTo = (path: string) => {
    history.push(path);
  };
  const isMobile = detectMobile();
  const handleContinue = async () => {
    try {
      const hhsrsHazardAssessmentCompletedNow = true;
      const hazardAssessmentResponse = await createHazardAssessmentApi();
      dispatch(saveHazardPostAssessmentResponse(hazardAssessmentResponse));
      const repairPriorityResponse = await callRepairPriorityDetermination(hazardAssessmentResponse);
      let resolvedPriorityCode: any = null;
      if (!isNullOrUndefined(repairPriorityResponse)) {
        resolvedPriorityCode = repairPriorityResponse?.repairPriority;
        dispatch(repairPriorityValue(resolvedPriorityCode));
      }

      dispatch(saveHHSRSAssessmentCompleted(hhsrsHazardAssessmentCompletedNow));

      if (hhsrsHazardAssessmentCompletedNow) {
        workOrderObject.repairCauseId = Helper.HHSRSRepairCauseId;
        workOrderObject.repairCause =
          Helper.RepairCauseLabels[Helper.HHSRSRepairCauseId];
      }

      await UpdateWorkOrder(hazardAssessmentResponse, resolvedPriorityCode);
      dispatch(saveHHSRSAssessmentCompleted(true));

      // navigate to next page only after all APIs succeed
      navigateTo("/uploadmedia");
    } catch (e) {
      console.error(e);
      navigateTo("/GenericError");
    }
  };

  const getAssessmentPageNumber = (questionCode: string) => {
    const questionIndex = hazardQuestions.findIndex((question: any) => question.code === questionCode);
    return questionIndex === -1 ? -1 : questionIndex + 1;
  };

  const backButtonHandler = () => {
    let lastAnsweredAssessmentPage = -1;

    assessmentDetails.forEach((item: any) => {
      if (!item.answerCodes?.length) {
        return;
      }

      const pageNumber = getAssessmentPageNumber(item.code);
      if (pageNumber > lastAnsweredAssessmentPage) {
        lastAnsweredAssessmentPage = pageNumber;
      }
    });

    if (lastAnsweredAssessmentPage !== -1) {
      history.push(`/HazardAssessment/${lastAnsweredAssessmentPage}`);
      return;
    }

    if (selectedRepairReasonObj?.[0]?.isPreAssessmentRequired === true) {
      history.push("/HazardPreassessment");
      return;
    }

    history.push("/RepairAdditionalDetails");
  };
  const exitButtonHandler = () => {
    history.push("/Customer360View");
  }

  const handleEdit = (sequence: number) => {
    history.push(`/HazardAssessment/${sequence}`);
  };

  const renderHazardDetails = () => {
    if (isMobile) {
      return (
        <div className="hazard-mobile-list px-2">
          {assessmentDetails?.map((item: any) => (
            <div className="hazard-mobile-card mb-3" key={item.sequence}>
              <p className="hazard-mobile-question mb-3">{item.question}</p>

              <div className="hazard-mobile-answers mb-3">
                {item.answers?.map((answer: any, idx: number) => (
                  <span
                    key={`${item.sequence}-${item.code}-${answer}-${idx}`}
                    className="hazard-mobile-chip"
                  >
                    {answer}
                  </span>
                ))}
              </div>

              <button
                type={undefined}
                className="hazard-mobile-edit-btn bg-transparent border-0 p-0 m-0 text-teal text-lg cursor-pointer"
                onClick={() => handleEdit(item.sequence)}
                aria-label={t("confirmation_edit")}
              >
                <i className="fas fa-edit mr-1" aria-hidden="true"></i>
                {t("confirmation_edit")}
              </button>
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="confirmation-div-table">
        <div className="repair-text " id="confirmation-div-table">
          <ReactBootstrap.Table className="">
            <TableBody
              id="confirmation-table"
              className="w-full border border-grey"
            >
              {assessmentDetails?.map((item: any) => (
                <TableRow
                  key={item.sequence}
                  className={`flex items-center bg-white ${assessmentDetails?.length - 1 ? "border-b border-gray-300" : ""
                    }`}
                >
                  <TableCell className="w-55 p-3 firstcol">
                    <h6 className="text-base padding-new color_black global-txt">
                      {item.question}
                    </h6>
                  </TableCell>
                  <TableCell className="w-2/3 p-3 thirdcol paddright ">
                    <div className="edt-spc padding-new pr-8 flex flex-wrap gap-2">
                      {item.answers?.map((answer: any) => (
                        <span
                          key={`${item.sequence}-${item.code}-${answer}`}
                          className="cellTextColor"
                        >
                          {answer}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                  <TableCell className="w-2/3 p-3 thirdcol paddright">
                    <div className="edt-spc padding-new text-right pr-8">
                      <button
                        type={undefined}
                        data-testid="hazard-question-edit-icon"
                        className="bg-transparent border-0 p-0 m-0 text-teal text-lg cursor-pointer"
                        title={t("confirmation_edit")}
                        aria-label={t("confirmation_edit")}
                        onClick={() => handleEdit(item.sequence)}
                      >
                        <i
                          className="fas fa-edit"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </ReactBootstrap.Table>
        </div>
      </div>
    );
  };
  const callRepairPriorityDetermination = async (hazardAssessmentResponse: any) => {
    try {
      const payload: RepairPriorityPayload = {
        isEmergency: workOrderObject?.isEmergency,
        repairType: userChosenSOR,
        description: workOrderObject?.repairReason,
        channel: RepairChannel.CustomerSelfService,
        raisedDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
        premisesType: assetDetails?.assetType,
        riskRating: hazardAssessmentResponse[0]?.risk?.adjusted,
        assessmentType: hazardAssessmentResponse[0]?.hazardType,
        isAnaType: isAnaTypeValue,
        isV14Upgradable: isEnhancedDiagnosticsRepair ? repairDiagnosticData?.isV14Eligibile : selectedRepairReasonObject?.[0]?.isV14Upgradable,
        tenureCode: customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode ?? "",
        workProgramme: isEnhancedDiagnosticsRepair ? repairDiagnosticData?.workProgram : priorityWorkProgramme,
        hasSeasonalPriority: selectedRepairReasonObject?.[0]?.hasSeasonalPriority || false
      };
      const repairPriorityDeterminationResponse = await postRepairPriority(payload);
      return repairPriorityDeterminationResponse;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const createHazardAssessmentRequest = (): CreateHazardRequest => {
    const responses: HazardResponseRequest[] =
      hazardDetails?.map((item: any) => ({
        code: item.code,
        answers: item.answerCodes,
      })) || [];

    return {
      assetType: assetDetails?.assetType || "",
      hazardType: selectedRepairReasonObj?.[0]?.hazardType || "",
      contractorRating: null,
      hasAdditionalNeeds: isAdditionalNeedsUser || false,
      isSupportedResident: supportedResident || false,
      responses,
    };
  };

  const createHazardAssessmentApi = async () => {
    try {
      const request: CreateHazardRequest = createHazardAssessmentRequest();

      const existingAssessmentIdentifier =
        workOrderObject?.assessmentInformation?.identifier ||
        workOrderObject?.assessmentIdentifier;

      let response: any;
      if (existingAssessmentIdentifier) {
        // update returns single object, wrap in array so rest of the flow ([0]) stays same as create
        const updatedAssessment = await api.updateHazardAssessment(existingAssessmentIdentifier, request);
        if (updatedAssessment?.id && updatedAssessment.id !== existingAssessmentIdentifier) {
          throw new Error("Hazard assessment identifier changed");
        }
        response = [updatedAssessment];
      } else {
        response = await createHazardAssessment(request);
      }
      // keep identifier on work order, so if priority / work order update fails later, retry uses update and not create again
      if (response?.[0]?.id) {
        workOrderObject.assessmentIdentifier = response[0].id;
      }
      // Dispatching response to get risk rating and hazard info
      dispatch(saveHazardAccessResponse(response?.[0]))
      return response;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
  const UpdateWorkOrder = async (hazardAssessmentResponse?: any, resolvedPriorityCode?: any) => {
    try {
      const assessmentOutcome = hazardAssessmentResponse?.[0];
      const hazardInspectionSorCode = selectedRepairReasonObject?.[0]?.hazardSorCode;

      if (
        !assessmentOutcome?.id ||
        !assessmentOutcome?.hazardType ||
        !assessmentOutcome?.risk
      ) {
        throw new Error("Hazard assessment outcome is incomplete");
      }
      if (!hazardInspectionSorCode) {
        throw new Error("Hazard inspection SOR code is missing");
      }
      if (!resolvedPriorityCode) {
        throw new Error("Repair priority is missing");
      }

      workOrderObject.priority = resolvedPriorityCode;
      workOrderObject.hazardSorCode = hazardInspectionSorCode;
      workOrderObject.assessmentIdentifier = assessmentOutcome.id;
      if (resolvedPriorityCode === 'AWE') {
        workOrderObject.isEmergency = true;
      }
      else {
        workOrderObject.isEmergency = false;
      }
      saveAssessmentInformation(hazardAssessmentResponse?.[0]);
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      )
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const saveAssessmentInformation = (hazardAssessmentResponse?: any) => {
    const assessmentInformation = {
      type: hazardAssessmentResponse.hazardType,
      communicationPreference: null,
      hasAdditionalNeeds: isAdditionalNeedsUser,
      IsSupportedResident: supportedResident,
      identifier: hazardAssessmentResponse.id
    }
    workOrderObject.assessmentInformation = assessmentInformation;
  }

  return (
    <>
      <HeaderJourney />
      <div
        className="container-fluid parent-footer repair-request"
        id="repAddDet-container"
      >
        <div id="confirmation-main-div" className="global-txt">

          <h1 id="confirmation-h1" className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6 pt-20 mb-4 padding-repair">
            {t("Hazard_Review_Title")}</h1></div>
        <div className="global-txt mb-2 padding-repair">{t("Hazard_Review_Sub_Title")}</div>
        <div className="padding-repair">    <div className="ReviewHeaderText mb-4">{t("Hazard_Review_Head_Msg")}</div>
        </div>
        {assessmentDetails?.length > 0 && (
          <div>{renderHazardDetails()}</div>
        )}

        <div className="col-md-12 marginTop-auto" id="repAddDet-div5">
          <div className="row m-0 footer-actionbtn">
            <div className="col btn-top padding-repair mb-0">
              <BackModal
                id="repAddDet-backmodal"
                back={backButtonHandler}
              />
              <ExitModal id="repair-asset-exitmodal" exit={exitButtonHandler} />
            </div>

            <div className="col text-end pt-24 padding-repair">
              <Button
                id="btn_hhrs_continue"
                onClick={handleContinue}
                className="primary-btn"
              >
                {t("continuen_button")}{" "}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default HazardReview;